import React from "react";
import { Container } from "react-bootstrap";

function Footer(){
return(
    <footer>
        <Container fluid>
            <h2 className="footer-text">
            © 2024 Veegana. All rights reserved.
            </h2>
        </Container>
    </footer>
)
}

export default Footer;